// Stored CDR call status (report tables + calls table): 'connected' | 'failed' | 'abandoned'.
// Rows stored before the PBX sent callStatus have none — callers pass their old rule as the fallback.
export const CALL_STATUS_LABELS: Record<string, string> = {
  connected: 'Connected',
  failed: 'Failed',
  abandoned: 'Abandoned',
};

export const storedCallStatus = (row: any): string | null => {
  const status = String(row?.call_status || '').toLowerCase();
  return CALL_STATUS_LABELS[status] ? status : null;
};

export const isCallConnected = (row: any, fallback: boolean): boolean => {
  const status = storedCallStatus(row);
  return status ? status === 'connected' : fallback;
};

export const callStatusLabel = (row: any, fallbackConnected: boolean): string =>
  CALL_STATUS_LABELS[storedCallStatus(row) || (fallbackConnected ? 'connected' : 'failed')] as string;
